import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import apiService from '../services/api';
import logo from '../assets/re-stat-logo.svg';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiService.adminLogin(username, password);
      navigate('/portals');
    } catch (err: any) {
      setError(err.message || 'Accesso negato. Verifica le credenziali admin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: 'background.default' }}>
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 420 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box component="img" src={logo} alt="re-stat" sx={{ height: 60, mb: 1 }} />
          <Typography color="text.secondary">Pannello Amministrativo</Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField label="Username" fullWidth required autoFocus margin="normal"
            value={username} onChange={(e) => setUsername(e.target.value)} disabled={loading} />
          <TextField label="Password" type="password" fullWidth required margin="normal"
            value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} />
          <Button type="submit" variant="contained" fullWidth size="large" sx={{ mt: 2 }} disabled={loading}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : undefined}>
            {loading ? 'Accesso in corso…' : 'Accedi'}
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default Login;
